import { useState } from 'react';

import { useCountdown } from '@/hooks/use-countdown';

import type { OtpDispatch } from './types';

type Init = {
  resendCooldownSeconds: number;
  resendAttemptsRemaining: number;
  otpExpiresAt: string;
};

export function useOtpChallenge(init: Init) {
  const [resendDeadline, setResendDeadline] = useState(
    () => Date.now() + init.resendCooldownSeconds * 1000,
  );
  const [attemptsRemaining, setAttemptsRemaining] = useState(init.resendAttemptsRemaining);
  const [expiresAt] = useState(() => new Date(init.otpExpiresAt).getTime());

  const resendSecondsLeft = useCountdown(resendDeadline);
  const expirySecondsLeft = useCountdown(expiresAt);

  const canResend = resendSecondsLeft === 0 && attemptsRemaining > 0;
  const expired = expirySecondsLeft === 0;

  function onResend(dispatch: OtpDispatch) {
    setResendDeadline(Date.now() + dispatch.resendCooldownSeconds * 1000);
    setAttemptsRemaining(dispatch.resendAttemptsRemaining ?? 0);
  }

  return { resendSecondsLeft, attemptsRemaining, canResend, expired, onResend };
}
